import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { emsCompetition, emsTeam, emsVeto } from 'src/models/emsModels';
import { NotificationBar } from 'src/services/notification.service';
import { environment } from 'src/environment';
import { VetoInfoDialogComponent } from '../veto-info-dialog/veto-info-dialog.component';
import { ConfirmDialogDialog } from '../confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-veto-list',
  templateUrl: './veto-list.component.html',
  styleUrl: './veto-list.component.scss'
})
export class VetoListComponent {

  notificationBar: NotificationBar;
  workspaceID = "";
  displayedColumns: string[] = ['date', 'competition', 'match', 'concluded', 'info', 'delete'];
  vetoSource = new MatTableDataSource<emsVeto>;
  searchValue: string;
  competitions = Array<emsCompetition>();
  teams = Array<emsTeam>();
  isDeleteVeto = "";
  competitionsDBRef: any;
  teamsDBRef: any;
  vetosDBRef: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private title: Title, private location: Location, private snackBar: MatSnackBar, public dialog: MatDialog, private db: AngularFireDatabase, private router: Router) {
    this.notificationBar = new NotificationBar(snackBar);
  }

  ngOnInit() {  
    this.workspaceID  = this.location.path().split("/")[1];
    this.title.setTitle("Vetos - EsportsMS");
    this.loadCompetitions();
    this.loadTeams();
    this.loadVetos();
  }

  ngOnDestroy() {
    if (this.competitionsDBRef) {
      this.competitionsDBRef.off('value');
    };
    if (this.teamsDBRef) {
      this.teamsDBRef.off('value');
    };
    if (this.vetosDBRef) {
      this.vetosDBRef.off('value');
    };
  }

  searchVeto(event: Event) {
    this.searchValue = (event.target as HTMLInputElement).value;
    this.vetoSource.filter = this.searchValue.trim().toLowerCase();
  }

  loadVetos() {
    this.vetosDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies');
    this.vetosDBRef.on('value', x => {
      var rawData = x.toJSON();
      if (rawData) {
        var vetos = Object.keys(rawData).map(key => ({
          uid: key,
          ...rawData[key],
          actions: Object.values(rawData[key]?.actions??{}),
          pool: Object.values(rawData[key]?.pool??{})
        })) as emsVeto[];
        vetos = vetos.filter(x => x.workspace == this.workspaceID);
        vetos.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        this.vetoSource = new MatTableDataSource(vetos);
        this.vetoSource.sort = this.sort;
        this.vetoSource.paginator = this.paginator;
        if (this.searchValue != undefined) {
          this.vetoSource.filter = this.searchValue.trim().toLowerCase();
        }
      }
      else {
        this.vetoSource = new MatTableDataSource();
      }
    });
  }

  loadCompetitions() {
    this.competitionsDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/competitions').orderByChild('workspace').equalTo(this.workspaceID);
    this.competitionsDBRef.on('value', x => {
      this.competitions = new Array<emsCompetition>();
      x.forEach( x => {
        var competition = x.toJSON() as emsCompetition;
        competition.uid = x.key;
        this.competitions.push(competition);
      });
      this.competitions.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  loadTeams() {
    this.teamsDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/teams').orderByChild('workspace').equalTo(this.workspaceID);
    this.teamsDBRef.on('value', x => {
      this.teams = new Array<emsTeam>();
      x.forEach( x => {
        var team = x.toJSON() as emsTeam;
        team.uid = x.key;
        this.teams.push(team);
      });
      this.teams.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getCompetitionName(competitionID: string) {
    return this.competitions.find(x => x.uid == competitionID).name;
  }

  getTeamTricode(teamID: string) {
    return this.teams.find(x => x.uid == teamID).tricode;
  }

  goToLobby(lobbyCode: string) {
    var redirect = "/veto?lobby=" + lobbyCode;
    this.router.navigateByUrl(redirect);
  }

  showVetoInfo(veto: any) {
    var dialogRef = this.dialog.open(VetoInfoDialogComponent, {
      data: {
        veto: veto,
      }
    });
  }

  async deleteVeto(veto: any) {
    this.isDeleteVeto = veto.uid;
      var dialogRef = this.dialog.open(ConfirmDialogDialog, {
        data: {
          actionType: "delete",
          message: "Are you sure you want to delete the veto for " + this.getTeamTricode(veto.teamOne) + " vs " + this.getTeamTricode(veto.teamTwo) + "?",
        }
      });
      return dialogRef.afterClosed().toPromise().then(async res => {
        if (res == true) {
          this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + veto.uid).remove().then( x => {
            this.notificationBar.show("Veto deleted!");
          }, err => {
              this.notificationBar.showUnknownError();
          })
        }
        this.isDeleteVeto = "";
      });
    }
}
